import { classNames, utilityGroups, withoutOverriddenBy, } from '../../utils/style-class.utils';
export var h1 = 'font-semibold text-2xl ';
export var h2 = 'font-semibold text-xl ';
export var h3 = 'font-semibold text-lg ';
export var h4 = 'font-semibold text-base leading-snug ';
export var body = 'text-base font-h1';
export var help = 'text-sm font-h1';
export var button = 'font-semibold text-sm ';
export var buttonSmall = 'font-semibold text-xs ';
export var link = 'font-body ';
export var small = 'font-body ';
export var dropText = 'text-textDark font-body';
var skinnyWeight = 'font-normal';
var normalWeight = 'font-semibold';
var boldWeight = 'font-bold';
var getWeightStyles = function (weight) {
    switch (weight) {
        case 'skinny':
            return skinnyWeight;
        case 'bold':
            return boldWeight;
        case 'normal':
            return normalWeight;
        default:
            return skinnyWeight;
    }
};
var getUnderlineStyle = function (underline) {
    return "".concat(underline ? 'underline' : '');
};
var getHoverStyle = function (hover) { return "".concat(hover ? 'cursor-pointer' : ''); };
export var getFontStyleByType = function (type, weight, underline, hover) {
    switch (type) {
        case 'h1':
            return h1;
        case 'h2':
            return h2;
        case 'h3':
            return h3;
        case 'h4':
            return h4;
        case 'button':
            return button;
        case 'buttonSmall':
            return buttonSmall;
        case 'body':
            return classNames(body, getWeightStyles(weight), getUnderlineStyle(underline), getHoverStyle(hover));
        case 'help':
            return classNames(help, getWeightStyles(weight), getUnderlineStyle(underline), getHoverStyle(hover));
        case 'small':
            return classNames(small, getWeightStyles(weight), getUnderlineStyle(underline), getHoverStyle(hover));
        case 'unspecified':
            return classNames(getWeightStyles(weight), getUnderlineStyle(underline), getHoverStyle(hover));
        default:
            return 'text-base';
    }
};
export var withoutOverridden = function (styles, className) {
    return withoutOverriddenBy(styles, className, [
        utilityGroups.fontSize,
        utilityGroups.fontWeight,
        utilityGroups.fontFamily,
    ]);
};
//# sourceMappingURL=typography.styles.js.map